<template>
  <div class="modal-popup">
<!--    <div class="modal fade" id="exportToLogoPopup" tabindex="-1" role="dialog"  aria-hidden="true">-->
<!--      <div class="modal-dialog modal-dialog-centered" role="document">-->
<!--        <div class="modal-content">-->
<!--        <div class="modal-header">-->
<!--          <h3 class="title mb-2 ml-3">Logo Aktarım Durumu</h3>-->
<!--          <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
<!--            <span aria-hidden="true" class="la la-close"></span>-->
<!--          </button>-->
<!--        </div>-->
<!--          <div class="modal-body">-->
<!--            <div class="contact-form-action">-->
<!--              <div class="col-lg-12">-->
<!--                <div class="card-item" v-if="logoExportStatusList != null">-->
<!--                  <div class="row">-->
<!--                    <div class="contact-form-action col-sm-6">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="font-weight-bold label-text">Acente Adı</label>-->
<!--&lt;!&ndash;                        <span class="text"> €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="font-weight-bold label-text">Durumu</label>-->
<!--&lt;!&ndash;                        <span class="text"></span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="font-weight-bold label-text">Aktar</label>-->
<!--                        &lt;!&ndash;                        <span class="text"></span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="row"">-->
<!--                    <div class="contact-form-action col-sm-6">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="label-text">Web Acentesi</label>-->
<!--                        &lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" >-->
<!--&lt;!&ndash;                        <label class="label-text" :class="getStatusClass(exportStatus.status)">{{getStatusText(exportStatus.status)}}</label>&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" v-if="exportStatus !== 'ok'">-->
<!--                        <a @click="openWebExportModal()" class="a-logo-export">Aktar</a>-->
<!--                        &lt;!&ndash;                        <label class="label-text">{{exportStatus.status}}</label>&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="row" v-for="exportStatus in logoExportStatusList">-->
<!--                    <div class="contact-form-action col-sm-6">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="label-text">{{agencyMap[exportStatus.agencyId].name}}</label>-->
<!--&lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" >-->
<!--                        <label class="label-text" :class="getStatusClass(exportStatus.status)">{{getStatusText(exportStatus.status)}}</label>-->
<!--&lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="contact-form-action col-sm-3">-->
<!--                      <div class="input-box" v-if="exportStatus !== 'ok'">-->
<!--                        <a @click="sendToLogo(exportStatus.agencyId, exportStatus.sailId)" class="a-logo-export">Aktar</a>-->
<!--&lt;!&ndash;                        <label class="label-text">{{exportStatus.status}}</label>&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <span class="text">{{exportStatus.status}} €</span>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--&lt;!&ndash;                  <span v-if="checkChange.needRefund" class="badge badge-warning py-1 px-2"&ndash;&gt;-->
<!--&lt;!&ndash;                        style="color: white;">&ndash;&gt;-->
<!--&lt;!&ndash;                  İade yapılması gerekiyor!&ndash;&gt;-->
<!--&lt;!&ndash;                  </span>&ndash;&gt;-->
<!--&lt;!&ndash;                    <span v-if="checkChange.belowPartialPayment" class="badge badge-warning py-1 px-2"&ndash;&gt;-->
<!--&lt;!&ndash;                            style="background-color: #d32727;color: white;">&ndash;&gt;-->
<!--&lt;!&ndash;                    Parçalı ödeme limitinin altında!&ndash;&gt;-->
<!--&lt;!&ndash;                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                  <span v-if="checkChange.priceDifference === 0" class="badge badge-success py-1 px-2"&ndash;&gt;-->
<!--&lt;!&ndash;                        style="color: white;">&ndash;&gt;-->
<!--&lt;!&ndash;                  Değişiklik için ücret ödenmesi gerekmiyor.&ndash;&gt;-->
<!--&lt;!&ndash;                  </span>&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="contact-form-action ml-4">-->
<!--&lt;!&ndash;              <form method="post">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="col-sm-6">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="input-box">&ndash;&gt;-->
<!--&lt;!&ndash;                      <label class="label-text">Acente</label>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="form-group">&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                        <select v-model="selectedAgency" id="selectedAgency" class="select-contain-select" type="text" placeholder="" style="width: auto">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                          <option v-for="agency in agencyList" :value="agency" style="color: black"> {{agency.name}} </option>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                        </select>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;              </form>&ndash;&gt;-->
<!--            </div>-->
<!--            </div>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="modal-footer border-top-0 pt-0">&ndash;&gt;-->
<!--&lt;!&ndash;            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>&ndash;&gt;-->
<!--&lt;!&ndash;            <button @click="accept" :class="loading ? 'disabled' : ''" type="button" class="theme-btn theme-btn-small">&ndash;&gt;-->
<!--&lt;!&ndash;              <i v-if="loading" class="la la-spinner la-spin"></i>Onaylıyorum</button>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "ExportToLogoPopup",
  data:function (){
    return{
      loading:false
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    logoExportStatusList:{
      get(){
        let logoExportStatusList = this.$store.getters.getLogoExportStatusList
        if(!logoExportStatusList) return null;

        return logoExportStatusList.filter((logoExportStatus)=>{
          return logoExportStatus.agencyId !== 1;
        });
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    sail:{
      get(){
        return this.$store.getters.getSail;
      }
    }
  },
  methods:{
    sendToLogo(agencyId, sailId){
      if(!this.loading) {
        this.loading = true;
        this.$store.dispatch("sendToLogo", {agencyId:agencyId, sailId:sailId}).then(response => {
          if(response.Status === 'Error'){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.Message,
            })
          }else{
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
          }

        }).catch((error)=>{
          messagePopupManager.showError("Hata", error.response.data.message);
        }).finally(()=>{
          this.loading = false;
        })
      }
    },
    openWebExportModal(){
      $("#exportToLogoPopup").modal("hide");
      setTimeout(()=>{
        $("#exportToLogoWebAgencyPopup").modal("show");
      },400) // 400ms required for modal animation to end
    },
    getStatusClass(status){
      switch (status){
        case "ok" : return "status-ok";
        case "failed" : return "status-failed";
        case "none" : return "status-none";
      }
    },
    getStatusText(status){
      switch (status){
        case "ok" : return "başarılı";
        case "failed" : return "başarısız";
        case "none" : return "beklemede";
      }
    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>
.a-logo-export{
  cursor: pointer;
  color: #0d47a1;
}

.contact-form-action{
  padding: 0!important;
}

.status-failed{
  color: #e53935;
}

.status-ok{
  color: #0da33e;
}

.status-none{
  color: #9e9d24;
}

</style>